import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4378052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fileInputBox paddingRight" }
const _hoisted_3 = {
  key: 0,
  class: "inputBox__file-link mt--5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "hoverUnderline" }, "Список созданных элементов", -1))
const _hoisted_5 = { class: "fileInputBox__popup-menu" }
const _hoisted_6 = { class: "items-in-line" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "m-font-size mb--20 items-in-line flex-start" }
const _hoisted_9 = {
  key: 0,
  class: "update-developer-categories"
}
const _hoisted_10 = { class: "items-in-line" }
const _hoisted_11 = { key: 1 }

import { Ref, ref } from 'vue';
import {
  CreateDeveloperModal,
  DeleteDeveloperModal,
} from '@/components/ProfileComponents';
import { CreateCategoryModalType, DeleteCategoryModalType } from '@/types';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateCategories',
  props: {
    editableCategory: {},
    title: {},
    parentId: {},
    categoryId: {},
    isInput: { type: Boolean, default: false }
  },
  emits: ['changeCategory', 'createCategory', 'deleteCategory'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const createCategoryModalData: Ref<CreateCategoryModalType> = ref({
  show: false,
  categoryTitle: undefined,
  categoryId: undefined,
  parentId: undefined,
});
const deleteCategoryModalData: Ref<DeleteCategoryModalType> = ref({
  show: false,
  id: undefined,
});
const loading = ref(false);
const idDeleteBtnLoading: Ref<number | undefined> = ref(undefined);
const showCreateCategoryModal = (event: {
  categoryTitle: string;
  categoryId: string;
  parentId?: number;
}) => {
  createCategoryModalData.value = {
    show: true,
    categoryTitle: event.categoryTitle,
    categoryId: event.categoryId,
    parentId: event.parentId,
  };
};
const closeCreateCategoryModal = () => {
  createCategoryModalData.value = {
    show: false,
    categoryTitle: undefined,
    parentId: undefined,
    categoryId: undefined,
  };
};

const showDeleteCategoryModal = (id: number) => {
  deleteCategoryModalData.value = {
    show: true,
    id: id,
  };
};

const closeDeleteCategoryModal = () => {
  deleteCategoryModalData.value = {
    show: false,
    id: undefined,
  };
};

const createCategory = async (event: { id: number; title: string }) => {
  emit('createCategory', event);
};

const deleteCategory = async (id: number) => {
  emit('deleteCategory', id);
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_popup = _resolveComponent("base-popup")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_base_input, {
              id: "txt",
              label: _ctx.title,
              "append-icon": "add",
              type: "text",
              withoutFocus: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
            showCreateCategoryModal({
              categoryTitle: _ctx.title,
              categoryId: _ctx.categoryId,
              parentId: _ctx.parentId,
            })
          ))
            }, null, 8, ["label"])
          ]),
          (_ctx.editableCategory.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_base_popup, {
                  "show-close-icons": false,
                  start: ""
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editableCategory, (category, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "fileInputBox__popup-menu-item"
                        }, [
                          _createElementVNode("div", null, _toDisplayString(category.title), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_base_icon, {
                              clickable: "",
                              color: "black",
                              "font-size": "16",
                              height: "10",
                              name: "close",
                              width: "10",
                              onClick: ($event: any) => (showDeleteCategoryModal(category.id))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_base_icon, {
                              clickable: "",
                              color: "black",
                              "font-size": "16",
                              height: "10",
                              name: "edit",
                              width: "10",
                              onClick: ($event: any) => (_ctx.$emit('changeCategory', category.id))
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" Следующий шаг - создать " + _toDisplayString(_ctx.title) + " ", 1),
            _createVNode(_component_base_button, {
              text: _unref(useAppStore)().getWindowWidth() > 600 ? '+ Создать' : 'Создать',
              class: "scale",
              height: "36",
              uppercase: "",
              "without-active": "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
            showCreateCategoryModal({
              categoryTitle: _ctx.title,
              categoryId: _ctx.categoryId,
              parentId: _ctx.parentId,
            })
          ))
            }, null, 8, ["text"])
          ]),
          (_ctx.editableCategory.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editableCategory, (category) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_base_card, { class: "update-developer-categories__card" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(category.title), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_base_button, {
                            loading: idDeleteBtnLoading.value === category.id,
                            "style-type": "coloredBorder",
                            text: "Удалить",
                            onClick: ($event: any) => (showDeleteCategoryModal(category.id))
                          }, null, 8, ["loading", "onClick"]),
                          _createVNode(_component_base_button, {
                            text: "Редактировать",
                            onClick: ($event: any) => (_ctx.$emit('changeCategory', category.id))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, "Не найдено"))
        ])),
    _createVNode(_unref(CreateDeveloperModal), {
      "create-category-modal-data": createCategoryModalData.value,
      onClose: closeCreateCategoryModal,
      onCreateCategory: _cache[2] || (_cache[2] = ($event: any) => (createCategory($event)))
    }, null, 8, ["create-category-modal-data"]),
    _createVNode(_unref(DeleteDeveloperModal), {
      "delete-category-modal-data": deleteCategoryModalData.value,
      onClose: closeDeleteCategoryModal,
      onDeleteCategory: deleteCategory
    }, null, 8, ["delete-category-modal-data"])
  ]))
}
}

})